import React from 'react';
import { useBreakpoint, useResponsive } from '../hooks/useBreakpoint';

const ResponsiveHookTester: React.FC = () => {
  const breakpointData = useBreakpoint();
  const responsiveData = useResponsive();

  return (
    <div style={{
      backgroundColor: '#1a1a2e',
      border: '2px solid #667eea',
      borderRadius: '12px',
      padding: '20px',
      margin: '20px 0',
      color: '#ffffff',
      fontFamily: 'monospace'
    }}>
      <h3>🔧 Responsive Hook Testing</h3>
      
      <div style={{
        margin: '15px 0',
        padding: '15px',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        borderRadius: '8px'
      }}>
        <h4 style={{ margin: '0 0 10px 0', color: '#667eea' }}>useBreakpoint() Hook:</h4>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '10px'
        }}>
          <div style={{ background: 'rgba(255, 255, 255, 0.1)', padding: '8px', borderRadius: '4px' }}>
            <strong>Breakpoint:</strong> <span style={{ color: '#ffd700' }}>{breakpointData.breakpoint}</span>
          </div>
          <div style={{ background: 'rgba(255, 255, 255, 0.1)', padding: '8px', borderRadius: '4px' }}>
            <strong>Width:</strong> <span style={{ color: '#ffd700' }}>{breakpointData.width}px</span>
          </div>
          <div style={{ background: 'rgba(255, 255, 255, 0.1)', padding: '8px', borderRadius: '4px' }}>
            <strong>Height:</strong> <span style={{ color: '#ffd700' }}>{breakpointData.height}px</span>
          </div>
          <div style={{ background: 'rgba(255, 255, 255, 0.1)', padding: '8px', borderRadius: '4px' }}>
            <strong>isMobile:</strong> <span style={{ color: '#ffd700' }}>{breakpointData.isMobile.toString()}</span>
          </div>
          <div style={{ background: 'rgba(255, 255, 255, 0.1)', padding: '8px', borderRadius: '4px' }}>
            <strong>isTablet:</strong> <span style={{ color: '#ffd700' }}>{breakpointData.isTablet.toString()}</span>
          </div>
          <div style={{ background: 'rgba(255, 255, 255, 0.1)', padding: '8px', borderRadius: '4px' }}>
            <strong>isDesktop:</strong> <span style={{ color: '#ffd700' }}>{breakpointData.isDesktop.toString()}</span>
          </div>
        </div>
      </div>

      <div style={{
        margin: '15px 0',
        padding: '15px',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        borderRadius: '8px'
      }}>
        <h4 style={{ margin: '0 0 10px 0', color: '#667eea' }}>useResponsive() Hook:</h4>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '10px'
        }}>
          <div style={{ background: 'rgba(255, 255, 255, 0.1)', padding: '8px', borderRadius: '4px' }}>
            <strong>isMobileOrTablet:</strong> <span style={{ color: '#ffd700' }}>{responsiveData.isMobileOrTablet.toString()}</span>
          </div>
          <div style={{ background: 'rgba(255, 255, 255, 0.1)', padding: '8px', borderRadius: '4px' }}>
            <strong>showSidebar:</strong> <span style={{ color: '#ffd700' }}>{responsiveData.showSidebar.toString()}</span>
          </div>
          <div style={{ background: 'rgba(255, 255, 255, 0.1)', padding: '8px', borderRadius: '4px' }}>
            <strong>useBottomNav:</strong> <span style={{ color: '#ffd700' }}>{responsiveData.useBottomNav.toString()}</span>
          </div>
        </div>
      </div>

      <div style={{ marginTop: '20px' }}>
        <h4 style={{ color: '#667eea' }}>Visual Breakpoint Indicator:</h4>
        <div style={{
          padding: '15px',
          borderRadius: '8px',
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: '1.2em',
          textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
          background: breakpointData.breakpoint === 'mobile' 
            ? 'linear-gradient(135deg, #ef4444, #dc2626)'
            : breakpointData.breakpoint === 'tablet'
            ? 'linear-gradient(135deg, #f59e0b, #d97706)'
            : breakpointData.breakpoint === 'desktop'
            ? 'linear-gradient(135deg, #22c55e, #16a34a)'
            : 'linear-gradient(135deg, #3b82f6, #2563eb)'
        }}>
          Current: {breakpointData.breakpoint.toUpperCase()} ({breakpointData.width}px)
        </div>
      </div>
    </div>
  );
};

export default ResponsiveHookTester;
